import { render } from "./HomeDescription.vue?vue&type=template&id=4809e2af&scoped=true"
import script from "./HomeDescription.vue?vue&type=script&lang=js"
export * from "./HomeDescription.vue?vue&type=script&lang=js"

import "./HomeDescription.vue?vue&type=style&index=0&id=4809e2af&scoped=true&lang=css"

import exportComponent from "/home/denis/Projects/tavria/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4809e2af"]])

export default __exports__